var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    fill: "red",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.728,12.64l-3.596-5.14,3.588-5.113c.323-.459,.362-1.055,.103-1.553-.259-.499-.769-.809-1.331-.809H3.496C1.566,.025-.004,1.596-.004,3.526l.004,19.974c0,.276,.224,.5,.5,.5s.5-.224,.5-.5V15H22.498c.562,0,1.071-.31,1.331-.807,.259-.498,.221-1.093-.101-1.554Zm-.786,1.092c-.088,.168-.254,.269-.444,.269H.998l-.002-10.474C.996,2.147,2.118,1.025,3.496,1.025H22.491c.19,0,.356,.101,.444,.27,.087,.169,.075,.362-.034,.518l-3.789,5.4c-.121,.172-.121,.401,0,.574l3.797,5.426c.109,.156,.121,.35,.034,.519Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedFlag);
export default __webpack_public_path__ + "static/media/redFlag.261e42846d5c3f2763ece500a9e1a1ec.svg";
export { ForwardRef as ReactComponent };